import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ListItem {
  id: string;
  text?: string;
  icon?: string;
  disabled?: boolean;
}

@Component({
  selector: 'custom-list',
  templateUrl: './custom-list.component.html',
  styleUrls: ['./custom-list.component.scss'],
})
export class CustomListComponent {
  @Input() items!: ListItem[];
  @Output() onSelect = new EventEmitter<string>();

  public selectedItem = '';

  public select(item: ListItem) {
    if (!item.disabled) {
      this.onSelect.emit(item.id);
    }
  }
}
